import React, { useEffect, useState } from 'react'
import ConfigurationHeader from '../../components/heading/ConfigurationHeader'
import Input, { DashboardCheckbox, InputList } from '../../components/Input/Input'
import { configurationAttributeType, newConfigurationNames, schemeConfigurationValuesTypes } from '../../types'
import { popupType } from '../../types/types'
import { convertValuesToConfig, createValidation, getMetaDataConfig, getNewConfiguration, postConfiguration, updateConfiguration } from '../../services/uiConfigService'
import * as yup from 'yup'
import { GenericPopUp } from '../../components/popup/genericPopUp'
import * as Sentry from "@sentry/react";
import { IndentWrapper } from '../orderConfiguration/OrderConfiguration'
import QuestionHeading from '../../components/heading/QuestionHeading'
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions'
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes'
import { deepClone } from '@mui/x-data-grid/utils/utils'
import { schemeDefaultValues } from '../defaultConfigurations/schemeConfigDefaultValue'
import './SchemeConfiguration.css'


const SchemesConfiguration = (props: { showBackButton?: boolean }) => {
    const [schemeConfig, setSchemeConfig] = useState<configurationAttributeType[]>([]);
    const [values, setValues] = useState<schemeConfigurationValuesTypes>(deepClone(schemeDefaultValues))
    const [schemeValidationsSchema, setSchemeValidationSchema] = useState({})
    const [openGenericModal, setOpenGenericModal] = useState(false);
    const [popupType, setPopupType] = useState<popupType>("Alert");
    const [genericMessage, setGenericMessage] = useState("");


    const openPopup = (message: string, type: popupType) => {
        setPopupType(type)
        setGenericMessage(message)
        setOpenGenericModal(true)
    }
    useEffect(() => {
        const getcustomerConfiguration = async () => {
            try {
                const resp = await getNewConfiguration('scheme_configuration');
                const customer_config: configurationAttributeType[] = resp?.domainValues;
                setSchemeConfig([...customer_config])
            } catch (err) {
                Sentry.captureException(err);
            }
        }
        getcustomerConfiguration();
    }, [])


    const saveConfiguration = async (preview?: boolean) => {
        validateWithOtp(async (verifiedUser?: manageUpdateAccessObj) => {
            try {

                const configName = (preview ? "scheme_configuration_preview" : "scheme_configuration")
                const schemeSchema = yup.object({ ...schemeValidationsSchema })
                const validationObject: any = {};
                Object.keys(values).forEach(key => {
                    validationObject[key] = values[key].value;
                })
                // await schemeSchema.validate(validationObject)
                const convertedVals = convertValuesToConfig(values, schemeConfig);
                let clientConfig = await getMetaDataConfig("clientconfig");
                if (clientConfig.find((config: { domainType: string }) => config.domainType === configName)) {
                    await updateConfiguration(configName, convertedVals, verifiedUser)
                } else
                    await postConfiguration(configName, convertedVals, verifiedUser)
                openPopup("Configuration Updated", 'Success')

            } catch (err) {
                Sentry.captureException(err);
                console.log("err===", err)
                if (err instanceof Error)
                    openPopup("Validation Error occured : " + err?.message, 'Error')
            }
        })

    }


    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: { ...values[keyName], value: e.target.value, isValueUpdated: true }
        })
    }

    const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: { ...values[keyName], value: e.target.checked, isValueUpdated: true }
        })
    }

    const setSchemeConfigValues = () => {
        try {
            if (schemeConfig.length) {
                const result = { ...values }
                const resValidations = {} as { [key: string]: ReturnType<typeof createValidation> }
                schemeConfig.forEach((attr) => {
                    resValidations[attr.name] = createValidation(attr)
                    result[attr.name] = attr
                })
                setValues({ ...result as schemeConfigurationValuesTypes });
                setSchemeValidationSchema({ ...resValidations })
            }
        } catch (err) {
            Sentry.captureException(err);
        }
    }

    useEffect(() => {
        setSchemeConfigValues();
    }, [schemeConfig])


    return (
        <div className="scheme_config_container">
            <ConfigurationHeader heading={"Scheme Configuration"} showBackButton={props.showBackButton} saveConfiguration={() => saveConfiguration(false)} createPreview={() => saveConfiguration(true)} />
            <div className="config_form_container">

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        want to enable scheme upto label?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.uptoSchemeLabel.value} name="uptoSchemeLabel" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        createCustomSchemeText
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.createCustomSchemeText.value} name="createCustomSchemeText" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        viewSchemeCount
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.viewSchemeCount.value} name="viewSchemeCount" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        showViewAllForSchemes
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.showViewAllForSchemes.value} name="showViewAllForSchemes" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        schemeWithSequence
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.schemeWithSequence.value} name="schemeWithSequence" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        slabVisibilityInSchemes
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.slabVisibilityInSchemes.value} name="slabVisibilityInSchemes" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        uptoSchemeAmountThreshhold
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.uptoSchemeAmountThreshhold.value} onChange={handleValueChange} name="uptoSchemeAmountThreshhold" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        uptoSchemeItemThreshhold
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.uptoSchemeItemThreshhold.value} onChange={handleValueChange} name="uptoSchemeItemThreshhold" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        uptoSchemePercentThreshhold
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.uptoSchemePercentThreshhold.value} onChange={handleValueChange} name="uptoSchemePercentThreshhold" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <InputList values={values} question="schemeDisclaimers" setValues={setValues} configName="schemeDisclaimers" />
                </IndentWrapper>

            </div>
            <GenericPopUp message={genericMessage}
                type={popupType}
                openGenericModal={openGenericModal}
                setOpenGenericModal={setOpenGenericModal} />
        </div>
    )
}

export default SchemesConfiguration